import React from 'react';
import { useGeneralHooks } from '../../../Hooks/hooks';
import useHomeHeader from './homeHeader-hooks';
import { useDrawerHooks } from '../../Drawer/drawer-hooks';
import { IUser } from '../../../Interfaces/responseTypes';
import UserAvatar from '../../Avatars/UserAvatar/userAvatar';
import {  HomeHeaderNavs } from '../../../Interfaces/componentTypes';
import HomeHeaderMobile from './homeHeaderMobile';
import CustomDrawer from '../../Drawer/CustomDrawer/customDrawer';
import UserDrawer from '../../Drawer/DrawerContents/UserDrawer/userDrawer';
import MainLogo from '../../Logos/mainLogo/mainLogo';
import { Menu } from '../../../Assets/Icons';
import styles from './homeHeader.module.scss';

interface IProps {
    user: IUser,
    onNavHandle: (title: HomeHeaderNavs) => void;
    active: HomeHeaderNavs
}

const HomeHeader: React.FC<IProps> = (props) => {
    const { user, onNavHandle, active } = props;
    const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
    const { largeScreen } = useGeneralHooks();
    const { homeNavs } = useHomeHeader();

    return (
        <>
            {
                largeScreen
                    ?
                    <>
                        <div className={styles.header}>
                            <MainLogo />
                            <div className={styles.navContainer}>
                                <nav className={styles.navBox}>
                                    {/* {
                                        homeNavs.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className={active !== item.id ? styles.navItem : styles.navItemChecked}
                                                    onClick={() => onNavHandle(item.id)}
                                                >
                                                    <p>{item.title}</p>
                                                </div>
                                            )
                                        })
                                    } */}
                                </nav>
                                < div className={styles.navBox2}>
                                    <UserAvatar user={user} />
                                    <div className={styles.menuIcon}>
                                        <img src={Menu} alt="menuIcon" onClick={onOpenDrawer} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CustomDrawer
                            children={
                                <UserDrawer
                                    user={user}
                                />
                            }
                            open={openDrawer}
                            onClose={onCloseDrawer}
                        />
                    </>
                    :
                    <HomeHeaderMobile
                        user={user}
                        active={active}
                        onNavHandle={onNavHandle}
                    />
            }

        </>
    )
}

export default HomeHeader
